import { render } from "./AddSubProcessModal.vue?vue&type=template&id=32748b9c&scoped=true&ts=true"
import script from "./AddSubProcessModal.vue?vue&type=script&lang=ts"
export * from "./AddSubProcessModal.vue?vue&type=script&lang=ts"

import "./AddSubProcessModal.vue?vue&type=style&index=0&id=32748b9c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32748b9c"]])

export default __exports__